module.exports = __webpack_public_path__ + "static/pizza_7-68628e56da8d071f187d6f6b16de9697.jpg";